import QuillEditor from "components/Systems/QuillEditor/QuillEditor";

export default QuillEditor;
